export default __webpack_public_path__ + "static/media/AngusNormal.166620ba.jpg";